<template lang="pug">
.content
  .row
    .col-md-12
      .box-header-classes-me
        a.tab-link(:class="isActive == 1 ? 'active' : ''" @click="routeHref('classes_to_me_chat')") Chat
        a.tab-link(:class="isActive == 2 ? 'active' : ''" @click="routeHref('classes_to_me_exercise')" v-if="isPublic") Bài tập
        a.tab-link(:class="isActive == 3 ? 'active' : ''" @click="routeHref('classes_to_me_video')" v-if="isPublic") Video
        a.tab-link(:class="isActive == 4 ? 'active' : ''" @click="routeHref('classes_to_me_lesson')" v-if="isPublic") Lý thuyết
      .box-body-classes-me
        div(v-if="isActive == 1")
          FrontChat
        div(v-else-if="isActive == 2 && isPublic")
          FrontExercise(:pcID="pcID" :classID="classID" :pcInfo="pcInfo")
        div(v-else-if="isActive == 3 && isPublic" :pcInfo="pcInfo")
          FrontVideo(:pcID="pcID" :classID="classID" :pcInfo="pcInfo")
        div(v-else-if="isActive == 4 && isPublic")
          FrontLesson(:pcID="pcID" :classID="classID" :pcInfo="pcInfo")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import graphqlfront from '../Model/graphqlfront'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import FrontChat from '../ClassesMe/Chat'
import FrontLesson from '../ClassesMe/Lesson'
import FrontVideo from '../ClassesMe/Video'
import FrontExercise from '../ClassesMe/Exercise'
export default {
  components: {
    FrontChat,
    FrontLesson,
    FrontVideo,
    FrontExercise,
    MdNotification
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      loader: null,
      increment: 0,
      classID: 0,
      channelID: 0,
      pcID: 0,
      pcInfo: null,
      isPublic: false,
      isActive: 4,
      lstChannel: []
    }
  },
  async mounted () {
    if (this.$route.query.id !== null && !isNaN(this.$route.query.id) && this.$route.query.id > 0) {
      this.classID = Number(this.$route.query.id)
      await this.getClassPC()
      await this.syncChannel()
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    async getInfoPC(pcID) {
      if (pcID > 0) {
        var variables = {
          where: {id: {_eq: pcID}}
        }
        const {data} = await this.$apollo.query({
          query: gql(graphqlfront.GET_PC_WHERE_ANY),
          fetchPolicy: 'no-cache',
          variables: variables
        })
        if (data.private_community && data.private_community.length > 0) {
          this.pcInfo = data.private_community[0]
        }
      }
    },
    async getClassPC() {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_OF_PC),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            id: {_eq: this.classID}
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      })
      if (data.classes !== null && data.classes.length > 0) {
        this.pcID = data.classes[0].pc_id
        this.getInfoPC(this.pcID)
      }
    },
    async syncChannel() {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CHANNEL),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            classes_id: {'_eq': this.classID}
          },
          order_by: {private: 'desc'}
        }
      })
      if (data.channel && data.channel.length > 0) {
        this.lstChannel = data.channel
        this.isPublic = this.lstChannel[0].private
      }
    },
    routeHref(routeName) {
      if (this.lstChannel.length > 0) {
        this.$router.push({name: routeName, query: {id: this.classID}, params: {reload: 1}})
      }
    }
  },
  watch: {
    '$route': function(from, to) {
      if (this.$route.name === 'classes_to_me_chat') this.isActive = 1
      else if (this.$route.name === 'classes_to_me_exercise') this.isActive = 2
      else if (this.$route.name === 'classes_to_me_video') this.isActive = 3
      else if (this.$route.name === 'classes_to_me_channel' || this.$route.name === 'classes_to_me_lesson') this.isActive = 4
      if (this.$route.params.alias !== undefined && this.$route.params.alias !== null && this.$route.params.alias !== '') {
        var returnObj = this.lstChannel.filter(obj => this.$mycontroller.doSanitizeTitle(obj.name) === this.$route.params.alias)
        if (returnObj && returnObj.length > 0) this.isPublic = returnObj[0].private
      }
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
  .box-header-classes-me{
    .tab-link{cursor: pointer; color: #343A40; font-size: 15px; box-shadow: 0px 3px 6px #00000029; border-radius: 30px; background: #FAFAFA 0% 0% no-repeat padding-box; padding: 8px 16px; display: inline-block; margin-right: 8px;
      &:last-child{margin-right: 0;}
      &.active{background: #FBF4D2 0% 0% no-repeat padding-box; font-weight: bold;}
    }
  }
  .box-body-classes-me{margin-top: 24px;
    .no-data{text-align: center;margin: 15px 0;color: #9F6A28;font-size: 15px;}
  }
  .box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media screen and (min-width: 768px){
  
}
@media screen and (max-width:414px){
  .box-header-classes-me{ margin: 0 auto; text-align: center;
    .tab-link{width: 48%; display: inline-block; margin-bottom: 10px;
      &:nth-child(2n){margin-right: 0;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// detail.vue?74d84016